<template>
    <div> <a-tabs @change="callback" >
        <a-tab-pane key="1" tab="阶段标准" >
            <AdetectUvSuggest/>
        </a-tab-pane>
        <a-tab-pane key="2" tab="多年增长标准值">
            <UvAllForm :num="num"/>
        </a-tab-pane>

    </a-tabs></div>
</template>

<script>
    import AdetectUvSuggest from "./components/adetectUvSuggest"
    import UvAllForm from "./components/uvAllForm"
    export default {
        name: "index",
        data(){
            return{
                num:1
            }
        },
        components:{AdetectUvSuggest,UvAllForm},
        created() {
            this.$store.state.adminleftnavnum = "/WebsiteDetection/UVstandard"; //设置左侧导航2-2 active
        },
        methods:{
            callback(key) {
                this.num=key
            },
        }
    }
</script>

<style scoped>

</style>
